import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserStore } from '../lib/userStore';
import { getCurrentTenantConfig, getTenantAwarePath } from '../lib/tenantStore';
import { isPathAllowed } from '../lib/tenantConfig';

/**
 * Garde de routing pour tenants avec `allowedPaths` (actuellement : TSLH).
 *
 * Si l'utilisateur navigue vers une route non-autorisée pour son tenant,
 * on le redirige vers /my-office (ou /auth s'il n'est pas connecté).
 *
 * Ne fait rien pour :
 *   - tenant "default" (allowedPaths null)
 *   - tenant "arsenal" (allowedPaths null — Arsenal utilise déjà is_bpm_session)
 *   - utilisateur sans session TSLH active (évite les faux positifs pendant l'auto-join)
 */
export function TenantRouteGuard() {
  const navigate = useNavigate();
  const location = useLocation();
  const username = useUserStore((s) => s.username);
  const isTslhSession = useUserStore((s) => s.is_tslh_session);

  useEffect(() => {
    const config = getCurrentTenantConfig();
    if (!config.allowedPaths) return;
    // On applique le guard uniquement quand la session TSLH est établie
    // pour ne pas bloquer /auth avant login.
    if (!isTslhSession) return;
    if (!username) return;

    if (!isPathAllowed(config.id, location.pathname)) {
      navigate(getTenantAwarePath('/my-office'), { replace: true });
    }
  }, [location.pathname, isTslhSession, username, navigate]);

  return null;
}
